<template>
  <teleport to="#app-notification">
    <topbar-notification v-if="moment().isSame(dayOfEvent, 'day')">
      <bg-text>
        Conheça o novo Pix Automático da Transfeera — Lançamento ao vivo hoje! <a
          href="https://materiais.transfeera.com/webinar-pix-automatico"
        >Estamos ao vivo.</a>
      </bg-text>
    </topbar-notification>
    <topbar-notification
      v-else-if="moment().isBefore(dayOfEvent, 'day')"
      :checkpoint="checkpoint.AUTOMATIC_PIX_BANNER"
    >
      <bg-text>
        Conheça o novo Pix Automático da Transfeera — Lançamento ao vivo no dia 28/11! <a
          href="https://materiais.transfeera.com/webinar-pix-automatico"
        >Garanta sua vaga aqui</a>.
      </bg-text>
    </topbar-notification>
  </teleport>
</template>

<script setup>
import TopbarNotification from '@/commons/components/presentational/TopbarNotification.vue';
import checkpoint from '@/commons/constants/checkpoint';
import { BgText } from '@transfeeradev/bridge';
import moment from '@transfeeradev/moment';

const dayOfEvent = moment('2025-11-28');
</script>
